import { convertStyleData, transformPx2Rem } from '@utils/tools';
import { appMethod as app } from '@utils/app';

import './PicOptionsCustomComponent.less';

export default function PicOptionsCustomComponent(props) {
  /**
   * 传入数据
   */ 
  const data = props.data;                // 组件数据
  const detailData = props.detailData;    // 详情页数据
  const dynamicData = props.dynamicData;  // 动态数据
  const formCompindex = props.formCompindex;    // 动态表单索引
  const form_data = props.form_data || {};      // 动态表单传入数据
  const picOptions = data.picOptions || [];  
  /**
   * 组件配置对象
   */  
  const customFeature = data.customFeature;
  /**
   * 样式数据处理
   */
  const styleObj = convertStyleData(data.style);
  const titleStyleObj = {
    textAlign: customFeature.title_style['text-align'],
    color: customFeature.title_style['color'],
    backgroundColor: customFeature.title_style['background-color'],
    fontSize: transformPx2Rem(customFeature.title_style['font-size'], 320),
    lineHeight: transformPx2Rem(customFeature.title_style['line-height'], 320),
    fontWeight: customFeature.title_style['font-weight'],
    fontStyle: customFeature.title_style['font-style'],
    textDecoration: customFeature.title_style['text-decoration']
  }
  const itemStyleObj = {
    width: transformPx2Rem(customFeature.pic_style.width, 320),
    height: transformPx2Rem(customFeature.pic_style.height, 320)
  }
  const iconGouStyleObj ={
    background: `-webkit-gradient(linear, right top, left bottom, from(${customFeature.pic_style['border-active-color']}), color-stop(0.5, ${customFeature.pic_style['border-active-color']}),color-stop(0.5, rgba(255, 0, 0,0)), to(rgba(255, 0, 0,0)))`
  }
  const picStyleObj = {
    width: transformPx2Rem(customFeature.pic_style.width, 320),
    height: transformPx2Rem(customFeature.pic_style.height, 320),
    borderColor: customFeature.pic_style['border-color'],
    borderRadius: customFeature.pic_style['border-radius'],
    borderStyle: customFeature.pic_style['border-style'],
    borderWidth: customFeature.pic_style['border-width'],
  }
  const selectedPicStyleObj = {
    ...picStyleObj,
    borderColor: customFeature.pic_style['border-active-color']
  }
  /**
   * 组件内容处理
   */   
  let content = data.content;
  const segment = customFeature.segment; // 已绑定字段
  // 是否有绑定字段
  if (segment) {
    if (detailData && detailData[segment]) {
      content = detailData[segment];    // 当前组件处于详情页数据并已绑定某字段
    } else if (dynamicData && dynamicData[segment]) {
      content = dynamicData[segment];   // 当前组件有动态数据并已绑定某字段（TODO: 如果content为富文本，需要处理）
    }
  }
  /**
   * 绑定事件
   */
  function selectPicOption(src, index) {
    let pageInstance = app.getAppCurrentPage();
    let compindex    = props.index;
    let formcompindex = formCompindex;
    let segment      = customFeature.segment;
    let componentKey = 'eles[' + formcompindex +'].content[' + compindex + ']';
    let datakey = `eles[${formCompindex}].form_data.${customFeature.segment}`;
    let name = customFeature.name;
    let max = customFeature.maxSelect;
    let multi = customFeature.multiSelection;
    let newdata = {};
  
    if (!segment) {
      app.showModal({
        content: '该组件【图片选项】未绑定字段 请在电脑编辑页绑定后使用'
      });
      return;
    }
    // 是否为多选
    if (multi) {
      let picOptions = data.picOptions || [];
      if (picOptions[index]) {
        picOptions[index] = null;
      } else {
        picOptions[index] = src;
      }
      newdata[componentKey + '.picOptions'] = picOptions;
      let selectPicOptions = picOptions.filter(Boolean);
      newdata[datakey] = selectPicOptions;
      if (selectPicOptions > max) {
        app.showModal({
          content: name + '最多选择' + max + '项'
        });
        return;
      }
    } else {
      let picOptions = data.picOptions || [];
      if (picOptions[index]) {
        picOptions = [];
      } else {
        picOptions = [];
        picOptions[index] = src;
      }
      newdata[componentKey + '.picOptions'] = picOptions;
      newdata[datakey] = picOptions;
    }
    pageInstance.setData(newdata);
  }
  function tapPrevewPictureHandler(event) {
    app.tapPrevewPictureHandler(event);
  }
  /**
   * 返回组件
   */ 
  return (
    <div className={`custom-component pic-options mode-${customFeature.mode}`} style={styleObj}>
      <div className="title" style={titleStyleObj}>{customFeature.name}</div>
      {customFeature.picOptions.map((item, index) => (
        <div className="pic-options-list" key={index} onClick={() => selectPicOption(item.pic, index)}>
          <div className="pic-options-item" style={itemStyleObj}>
            {
              picOptions[index] &&
              <div className="icon-moon icon-gou" style={iconGouStyleObj}></div>
            }
            <img src={item.pic} style={picOptions[index] ? selectedPicStyleObj : picStyleObj}/>
            <span className="icon-moon icon-big-pic"></span>
          </div>
          <div className="pic-options-name"
            onClick={tapPrevewPictureHandler}
            data-img={item.pic}
            data-imgarr={JSON.stringify(item.pic)}
          >{item.name}</div>
        </div>
      ))}
    </div>
  );
}


// WEBPACK FOOTER //
// ./src/custom-component/pic-options-custom-component/PicOptionsCustomComponent.jsx